import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class GetUnixService {

  constructor() { }

  getEpochData(dateVal){
    const dateMomnt = new Date(dateVal);
    return moment(dateMomnt).utc().valueOf();
  }

  getEpochCurrent(){
    const dateMomnt = new Date();
    return moment(dateMomnt).utc().valueOf();
  }

  getRealTime(value){
    return moment.unix(value*1000).local().toDate();
  }

  getRealTime2(value){
    return moment.unix(value/1000).local().toDate();
  }

  getRealTime3(value){
    return moment.unix(value).local().toDate();
  }

}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/get-unix.service.ts